import React from 'react'
import { Link } from 'react-router-dom'
import './style.css'
const Pricing = () => {
    return (
        <React.Fragment>
            <div id="generic_price_table">   
<section>
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <div class="price-heading clearfix">
                        <h1>Petition for Membership</h1>
                    </div>
                    <p>Become a member and gain access to networking and mentorship opportunities. Our network encompasses mentors who serve as Senior Executives of Fortune 500 Corporations, Government officials in the USA and Jamaica, entrepreneurs, athletes, healthcare professionals, engineers, academic researchers, heads of international organisations and technology leads. Our members also get discounts at select resorts, car rental companies and restaurants as part of our partnership with PriceCut !

​<br/>
​<br/>

Check out our membership packages!
​<br/>
​<br/>

​

NOTE: We are currently not accepting applications for new members, but go ahead and take a look at our packages ahead of the next application cycle. Click the "Petition Now" button under the desired membership package to sign up to be notified of when applications open.</p>
                </div>
            </div>
        </div>
        <div class="container">
            
            <div class="row">
                <div class="col-md-4">
                
                    <div class="generic_content clearfix">
                        
                        <div class="generic_head_price clearfix">
                        
                            <div class="generic_head_content clearfix">
                            
                                <div class="head_bg"></div>
                                <div class="head">
                                    <span>Silver</span>
                                </div>
                                
                            </div>
                            
                            <div class="generic_price_tag clearfix">  
                                <span class="price">
                                    <span class="sign">$</span>
                                    <span class="currency">499</span>
                                    <span class="cent">.99</span>
                                    <span class="month">/YEAR</span>
                                </span>
                            </div>
                            
                        </div>                            
                        
                        <div class="generic_feature_list">
                          <ul>
                              <li>10% discount on hotel stay with partner hotels</li>
                                <li>5% discount at partner restaurants</li>
                                <li>5 recommendations</li>
                                <li>10% discount on all JAYA networking events</li>
                            </ul>
                        </div>
                        
                        <div class="generic_price_btn clearfix">
                          <a herf="">Petition Now</a>
                        </div>
                        
                    </div>
                        
                </div>
                
                <div class="col-md-4">
                
                    <div class="generic_content active clearfix">
                        
                        <div class="generic_head_price clearfix">
                        
                            <div class="generic_head_content clearfix">
                            
                                <div class="head_bg"></div>
                                <div class="head">
                                    <span>Gold</span>
                                </div>
                                
                            </div>
                            
                            <div class="generic_price_tag clearfix">  
                                <span class="price">
                                    <span class="sign">$</span>
                                    <span class="currency">1499</span>
                                    <span class="cent">.99</span>
                                    <span class="month">/YEAR</span>
                                </span>
                            </div>
                            
                        </div>                            
                        
                        <div class="generic_feature_list">
                          <ul>
                              <li>10% discount at partner restaurants</li>
                                <li>10% discount on hotel stay with partner hotels</li>
                                <li>15 recommendations</li>
                                <li>10% discount at partner car rental companies</li>
                                <li>10% discount on all JAYA networking events</li>
                                <li>15% discount on JAYA pixie events</li>
                                <li>One guest at 30% discount for a JAYA pixie event</li>
                            </ul>
                        </div>
                        
                        <div class="generic_price_btn clearfix">
                          <a href="">Petition Now</a>
                        </div>
                        
                    </div>
                        
                </div>
                <div class="col-md-4">
                
                    <div class="generic_content clearfix">
                        
                        <div class="generic_head_price clearfix">
                        
                            <div class="generic_head_content clearfix">
                            
                                <div class="head_bg"></div>
                                <div class="head">
                                    <span>Platinum</span>
                                </div>
                                
                            </div>
                            
                            <div class="generic_price_tag clearfix">  
                                <span class="price">
                                    <span class="sign">$</span>
                                    <span class="currency">1999</span>
                                    <span class="cent">.99</span>
                                    <span class="month">/YEAR</span>
                                </span>
                            </div>
                            
                        </div>                            
                        <div class="generic_feature_list">
                            <ul>
                                <li>10% discount at partner restaurants</li>
                                <li>15% discount on hotel stay with partner hotels</li>
                                <li>Unlimited recommendations</li>
                                <li>15% discount with partner food deliveries</li>
                                <li>20% discount on flights to Jamaica with partner airlines</li>
                                <li>10% discount at partner car rental companies</li>
                                <li>25% discount on all JAYA networking events</li>
                                <li>20% discount on JAYA pixie events</li>
                                <li>Two guests at 30% discount each for JAYA pixie event</li>
                                <li>Two guests to attend a JAYA networking event for FREE</li>
                            </ul>
                        </div>
                        
                        <div class="generic_price_btn clearfix">
                          <a class="" href="">Petition Now</a>
                        </div>
                        
                    </div>
                        
                </div>
            </div>  
            
        </div>
    </section>             
 
</div>
        </React.Fragment>
    )
}

export default Pricing
